/* ============================================================
   LG STICKY CTA
   Shows once the buy box has scrolled away; hides again over the footer.

   IntersectionObserver, not a scroll handler — the lander's chrome ran its
   visibility logic on every scroll frame, and this needs none of that.
   ============================================================ */
(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.lgInit === 'true') return;
    bar.dataset.lgInit = 'true';

    var buyBox = document.querySelector(bar.dataset.watch || '.lg-product__purchase');
    var footer = document.querySelector('.footer, #shopify-section-footer');

    /* With nothing to watch, the bar has no rule for when it is useful, so it
       stays hidden rather than covering the page permanently. */
    if (!buyBox) return;

    var buyBoxVisible = true;
    var footerVisible = false;

    function apply() {
      var show = !buyBoxVisible && !footerVisible;
      bar.classList.toggle('is-in', show);
      document.body.classList.toggle('lg-has-sticky', show);
    }

    new IntersectionObserver(
      function (entries) {
        buyBoxVisible = entries[0].isIntersecting;
        apply();
      },
      { rootMargin: '0px 0px -20% 0px' }
    ).observe(buyBox);

    if (footer) {
      /* The footer only counts as "in the way" once it reaches the top 45% of
         the screen. Treating ANY sliver of footer as visible made the bar
         unshowable on short pages: on the flagship PDP the buy box ends at
         1860px and the footer begins at 2273px, so on an 844px viewport both
         were on screen at once for the entire gap and the bar never appeared.
         Shrinking the observer root to the top 45% gives a real window. */
      new IntersectionObserver(
        function (entries) {
          footerVisible = entries[0].isIntersecting;
          apply();
        },
        { rootMargin: '0px 0px -55% 0px' }
      ).observe(footer);
    }

    var scrollBtn = bar.querySelector('[data-lg-sticky-scroll]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        buyBox.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center',
        });
        /* Move focus as well as the viewport. Scrolling alone leaves a keyboard
           user's focus stranded on a bar that is about to hide itself. */
        var focusable = buyBox.querySelector('button, [href], input, select');
        if (focusable) {
          window.setTimeout(function () {
            focusable.focus({ preventScroll: true });
          }, 500);
        }
      });
    }

    apply();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lg-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
